<script>
import { mapState, mapActions } from 'vuex'
import VueApexCharts from 'vue-apexcharts'

export default {
   components: {
      VueApexCharts,
   },
   data() {
      return {
         isLoading: false,
      }
   },
   computed: {
      ...mapState({
         items: state => state.DashboardMppd.ratioFayankes,
         tahun: state => state.DashboardMppd.tahun,
         refreshTimestamp: state => state.DashboardMppd.refreshTimestamp,
         skin: state => state.appConfig.layout.skin,
      }),
      isDark() {
         return this.skin === 'dark'
      },
      chartSeries() {
         return this.items.map(item => Number(item.total) || 0)
      },
      chartLabels() {
         return this.items.map(item => item.nama)
      },
      chartOptions() {
         const textColor = this.isDark ? '#d0d2d6' : '#5e5873'

         return {
            chart: {
               type: 'pie',
               foreColor: textColor,
               toolbar: {
                  show: false,
               },
               fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
            },
            labels: this.chartLabels,
            colors: ['#7367f0', '#28c76f', '#ff9f43', '#ea5455', '#00cfe8', '#6610f2', '#20c997'],
            dataLabels: {
               enabled: true,
               formatter: val => `${Math.round(val)}%`,
               style: {
                  colors: ['#ffffff'],
               },
               dropShadow: {
                  enabled: true,
                  top: 1,
                  left: 1,
                  blur: 1,
                  opacity: 0.45,
               },
            },
            stroke: {
               show: true,
               colors: this.isDark ? ['#283046'] : ['#ffffff'],
               width: 2,
            },
            legend: {
               position: 'bottom',
               labels: {
                  colors: textColor,
               },
            },
            tooltip: {
               theme: this.isDark ? 'dark' : 'light',
               y: {
                  formatter: (value, { seriesIndex }) => {
                     const item = this.items[seriesIndex] || {}
                     return `${Number(value).toLocaleString('id-ID')} — ${item.nama || ''}`
                  },
               },
            },
         }
      },
   },
   watch: {
      tahun(newYear, oldYear) {
         if (newYear !== oldYear) this.loadData(newYear)
      },
      refreshTimestamp() {
         this.loadData(this.tahun)
      },
   },
   mounted() {
      this.loadData(this.tahun)
   },
   methods: {
      ...mapActions({
         getRatioFayankes: 'DashboardMppd/getRatioFayankes',
      }),
      async loadData(year) {
         if (this.isLoading) return
         this.isLoading = true
         try {
            await this.getRatioFayankes(year)
         } finally {
            this.isLoading = false
         }
      },
   },
}
</script>

<template>
   <b-row>
      <b-col cols="12">
         <b-card class="card-wrapper">
            <div class="d-flex justify-content-between align-items-center mb-1">
               <div>
                  <h4 class="mb-25">
                     Kategori Fayankes
                  </h4>
                  <small class="text-muted">Tahun {{ tahun }}</small>
               </div>
               <b-spinner v-if="isLoading" small variant="primary" />
            </div>
            <vue-apex-charts
               type="pie"
               height="350"
               :options="chartOptions"
               :series="chartSeries"
            />
         </b-card>
      </b-col>
   </b-row>
</template>

<style scoped>
.card-wrapper {
   border: 0;
   border-radius: 12px;
   box-shadow: 0 4px 24px rgba(34, 41, 47, 0.08);
}

.dark-layout .card-wrapper {
   box-shadow: 0 4px 24px rgba(0, 0, 0, 0.2);
}
</style>
